function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.097 20.078C2.834 20.078 1 18.251 1 16c0-2.251 1.834-4.078 4.097-4.078 2.262 0 4.097 1.827 4.097 4.078 0 2.251-1.835 4.078-4.097 4.078zM26.903 31c-2.262 0-4.097-1.826-4.097-4.078 0-2.252 1.835-4.077 4.097-4.077 2.263 0 4.097 1.825 4.097 4.077S29.166 31 26.903 31zM8.647 18.953l14.71 5.939-14.71-5.94zM26.903 1c-2.262 0-4.097 1.826-4.097 4.078 0 2.252 1.835 4.077 4.097 4.077C29.166 9.155 31 7.33 31 5.078S29.166 1 26.903 1zM8.647 13.047l14.71-5.939-14.71 5.94z",
  stroke: "#FFF",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgShare = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.a872c5cb.svg";
export { ForwardRef as ReactComponent };